<template>
  <div class="container-fluid">
    <div class="card shadow pt-2 ps-3 pe-3">
      <div class="row">
        <div class="col-md-4 mt-4">
          <div class="form-group">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="/inicio">Início</a>
                </li>
                <li class="breadcrumb-item">
                  <a href="/usuarios">Usuários</a>
                </li>
                <li class="breadcrumb-item">
                  <a style="color: grey; hover: none">Cadastrar Usuários </a>
                </li>
              </ol>
              <h3 style="color: #000; margin-left: 15px">Cadastrar Usuário</h3>
            </nav>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-6">
          <label>Nome</label>
          <input
            type="text"
            class="form-control"
            v-model="state.nome"
            placeholder="Insira o nome do usuário"
          />
        </div>

        <div class="col-6">
          <label>Email</label>
          <input
            type="text"
            class="form-control"
            v-model="state.email"
            placeholder="Insira o email do usuário"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label>Senha</label>
            <input
              type="password"
              class="form-control"
              v-model="state.password"
              placeholder="Insira a senha"
            />
          </div>
        </div>
      </div>

      <div class="row justify-content-end">
        <div class="col-auto">
          <button
            class="btn btn_voltar btn-secondary me-3"
            id="voltar-button"
            type="submit"
            @click="router.push({ name: 'usuarios' })"
          >
            Voltar
          </button>

          <button
            class="btn btn_salvar"
            id="submit-button"
            type="submit"
            @click="salvarUsuario()"
          >
            Cadastrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      id: "",
      nome: "",
      email: "",
      password: "",
    });
    onMounted(() => {
      if (router.currentRoute._value.params.id != undefined) {
        fetchUsuario();
      }
    });
    async function fetchUsuario() {
      try {
        const { data } = await services.usuario.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.id = data.id;
        state.nome = data.nome;
        state.email = data.email;
        state.password = data.password;
      } catch (error) {
        console.log(error);
      }
    }
    async function salvarUsuario() {
      let dados = {
        nome: state.nome,
        email: state.email,
        password: state.password,
        token,
      };
      if (!state.id) {
        try {
          await services.usuario.save(dados, token);
          router.push({ name: "usuarios" });
        } catch (error) {
          console.log(error);
        }
      } else {
        dados.id = state.id;
        try {
          await services.usuario.update(dados, token);
          router.push({ name: "usuarios" });
        } catch (error) {
          console.log(error);
        }
      }
    }
    return {
      salvarUsuario,
      router,
      state,
    };
  },
};
</script> 

<style scoped>
label {
  font-size: 14pt;
  color: #000;
  margin-bottom: 0;
}
input {
  border: solid 1px #000;
  margin-bottom: 10px;
  font-size: 12pt;
  color: #000;
}
input:focus {
  border: solid 1px blue;
}
.btn_salvar {
  background: green;
  color: #fff;
  transform: none;
}
.btn_salvar:hover {
  color: #fff;
}
.card {
  min-height: 94.8vh;
}
.breadcrumb {
  background: #fff;
  margin-bottom: 0;
}
a {
  color: #000;
  font-family: "PoppinsMedium";
  transition: 0.2s;
}
a:hover {
  color: #93c01f;
}
</style>